import { Grid } from "@mui/material";
import UsersDonutChart from "./UsersDonutChart";
import { DonutSegment } from "./usersApiMapping";

interface UsersFunnelDonutsProps {
  leadToQualifiedSegments: DonutSegment[];
  qualifiedByZipSegments: DonutSegment[];
  leads: number;
  qualified: number;
}

export default function UsersFunnelDonuts({
  leadToQualifiedSegments,
  qualifiedByZipSegments,
  leads,
  qualified,
}: UsersFunnelDonutsProps) {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={6}>
        <UsersDonutChart
          title="Lead to qualified"
          segments={leadToQualifiedSegments}
          centerValue={leads}
          centerLabel="Leads"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UsersDonutChart
          title="Qualified by zip code"
          segments={qualifiedByZipSegments}
          centerValue={qualified}
          centerLabel="Qualified"
        />
      </Grid>
    </Grid>
  );
}
